<div class="w-full flex flex-row justify-end my-5 pb-5">
  <div class="rounded-full bg-[#E5E8EB] w-fit px-1.5 text-xs text-[#74808B] mr-2 flex flex-row items-center justify-evenly">
    <div class="ml-1">
      {{perPageText}} per page:
    </div>
    <select class="bg-transparent" (change)="perPage(select.value)" #select aria-label="Select Per Page">
      <fa-icon class="text-[#8B96A2]" [icon]="faCaretDown" />
      <option value="25">25</option>
      <option value="50">50</option>
      <option value="100">100</option>
    </select>
  </div>
  <div class="rounded-full bg-[#E5E8EB] w-fit px-2 py-1 text-xs text-[#74808B] flex flex-row items-center">
    <button aria-label="Decrement Page" (click)="decrementPage()" [disabled]="currentPagination.page + 1 === 1">
      <fa-icon [ngClass]="currentPagination.page + 1 === 1? 'text-[#B9C2CA]' : 'text-[#74808B]'" [icon]="faChevronLeft" size="xs" />
    </button>
    <div class="mx-1">
      Page {{currentPagination.page + 1}}
    </div>
    <button aria-label="Increment Page" (click)="incrementPage()" [disabled]="currentPagination.maxpage === currentPagination.page || currentPagination.limit === 0">
      <fa-icon [ngClass]="currentPagination.maxpage === currentPagination.page || currentPagination.limit === 0? 'text-[#B9C2CA]' : 'text-[#74808B]'" [icon]="faChevronRight" size="xs" />
    </button>
  </div>
</div>
